<template>
  <div class="modal-wrapper">
    <div class="modal-steps-wrapper">
      <el-steps :active="modalPage" finish-status="success" :align-center=true class="modal-steps">
        <el-step
          title="Massnahme"
          class="curser"
          @click.native="setStepPage('massnahme')"
          :class="isLastPage() ? 'no-cursor' : null"
        >
        </el-step>
        <el-step
          title="Kontaktdaten"
          @click.native="isContactClickable() ? setStepPage('kontaktdaten'): null"
          :class="isLastPage() ? 'no-cursor' : null"
        >
        </el-step>
        <el-step
          title="Gesuchsdaten"
          @click.native="isApplicationClickable() ? setStepPage('gesuch'): null"
          :class="isLastPage() ? 'no-cursor' : null"
        >
        </el-step>
        <!--<el-step
          title="Ausdrucken"
          :class="isLastPage() ? 'no-cursor' : null"
        />-->
      </el-steps>
    </div>
    <application-intro v-if="tabName === 'massnahme'" />
    <application-person v-else-if="tabName === 'kontaktdaten'" />
    <application-form v-else-if="tabName === 'gesuch'" />
    <!--<form-submission v-else-if="tabName === 'abschluss'" />-->
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import ApplicationIntro from '@/components/application/Intro/ApplicationIntro.vue'
  import ApplicationPerson from '@/components/application/Person/ApplicationPerson.vue'
  import ApplicationForm from '@/components/application/Form/ApplicationForm.vue'
  // import FormSubmission from '@/components/application/FormSubmission.vue'

  export default {
    data: () => ({
      tabName: ''
    }),
    created () {
      const { tabName } = this.$route.params
      this.tabName = tabName
    },
    methods: {
      setStepPage (tabName) {
        const { modalMethod, draftId } = this.$route.params

        this.$router
          .push({
            name: 'uebersicht',
            params: {
              modalMethod,
              tabName,
              draftId
            }
          })
          .catch(() => {})
      },
      isContactClickable () {
        return this.finalApplicationType && this.finalCommunityId
      },
      isApplicationClickable () {
        return this.isContactClickable() && this.personId !== null && this.personContactId !== null
      },
      isLastPage () {
        return this.tabName === 'gesuch'
      }
    },
    computed: {
      ...mapState({
        modalPage: state => state.application.modalPage,
        finalApplicationType: state => state.application.createApplication.finalApplicationType,
        finalCommunityId: state => state.application.createApplication.finalCommunityId,
        personId: state => state.application.createApplication.formData.personId,
        personContactId: state => state.application.createApplication.formData.personContactId
      })
    },
    watch: {
      $route (to, from) {
        const { tabName } = to.params
        this.tabName = tabName
      }
    },
    components: {
      ApplicationIntro,
      ApplicationPerson,
      ApplicationForm
      // FormSubmission
    }
  }
</script>

<style lang="scss" scoped>
  .modal-wrapper{
    margin: 0 2rem 3rem;

    @include media-breakpoint-down(md) {
      margin: 0 0rem 3rem;
    }
  }

  .modal-steps-wrapper{
    position: absolute;
    right: 3rem;
    top: -1.3rem;

    .modal-steps::v-deep{
      .el-step{
        flex-basis: 15%;
        min-width: 120px;

        @include media-breakpoint-down(md) {
           min-width: 50px;
        }

        @include media-breakpoint-down(sm) {
           min-width: 50px;
        }
      }

      & .no-cursor{
        .el-step__icon{
          cursor: default;
        }
      }

      .el-step__icon{
        color: $magenta;
        padding: 1.2rem;
        cursor: pointer;
      }

      .el-step.is-horizontal .el-step__line{
        top: 19px;
      }

       .el-step__head.is-success{
         color: $green;
         border: $green;
       }

      .el-step__head.is-process .el-step__icon,
      .el-step__head.is-success .el-step__icon{
        background: $green;
        color: $gray;
        border-color: $green;
      }

      .el-step__head.is-process .el-step__icon {
        background: $white;
        color: $magenta;
        border-color: $magenta;
      }

      .el-step__head.is-wait .el-step__icon{
        color: $black-20;
      }

      .el-step__title{
        font-weight: $font-weight-base;
        font-size: $font-size-base;
        display: block;

        @include media-breakpoint-down(md) {
           display: none;
        }
      }

      .el-step__title.is-process{
        color: $magenta;
      }
      .el-step__title.is-success{
        color: $gray;
      }
    }
  }
</style>
